module.exports = __webpack_public_path__ + "images/huazhu5.jpg?v=1339f926";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/index/huazhu5.jpg
 ** module id = 110
 ** module chunks = 1 2
 **/